export default __webpack_public_path__ + "static/DigitalFinanceLogoWithSpacing-689666b48d7adb861614115f94bd4020.png";